export default {
    lastTenant(state) {
        return state.lastTenant;
    },
    tenant(state) {
        return state.tenant;
    },
    user(state) {
        return state.user;
    },
    curOrder(state) {
        return state.curOrder;
    },
    curOrderItem(state) {
        return state.curOrderItem;
    },
    splitReceipt(state) {
        return state.splitReceipt;
    },
    curUnpaidOrders(state) {
        return state.curUnpaidOrders;
    },
    pausedOrder(state) {
        return state.pausedOrder;
    },
    curTable(state) {
        return state.curTable;
    },
    curGuest(state) {
        return state.curGuest;
    },
    appConfig(state) {
        return state.appConfig;
    },
    device(state) {
        return state.device;
    },
    printConfig(state) {
        return state.printConfig;
    },
    isOnline(state) {
        return state.isOnline;
    },
    localConnection(state) {
        return state.localConnection;
    },
    syncInProgress(state) {
        return state.syncInProgress;
    },
    syncOptions(state) {
        return state.syncOptions;
    },
    workingDays(state) {
        return state.workingDays;
    },
    updatePending(state) {
        return state.updatePending;
    },
    impersonate(state) {
        return state.impersonate;
    },
    initialized(state) {
        return state.initialized;
    },
    trainingMode(state) {
        return state.trainingMode;
    },
    tableMode(state) {
        return state.tableMode;
    },
    tablePermissions(state) {
        return state.tablePermissions;
    },
    activePricelist(state) {
        return state.activePricelist;
    },
    unpaidOrders(state) {
        if (isAllegra) return state.curUnpaidOrders;

        return state.curUnpaidOrders.filter((order) => {
            const guestFlag = order.getGuestId() || 0;
            return guestFlag === state.curGuest;
        });
    },
    modules(state) {
        return state.modules;
    },
    integrations(state) {
        return state.integrations;
    },
    pendingCardPayment(state) {
        return state.pendingCardPayment;
    },
    kdsSettings(state) {
        return state.kdsSettings;
    },
    activeSector(state) {
        return state.activeSector;
    },
};
